// src/utils/attendanceCsv.js
// 出席記録(students コレクション)を受講記録CSVに変換する純粋関数群。

export const CSV_HEADERS = [
  "日付",
  "曜日",
  "時間",
  "校舎",
  "レッスン",
  "講師",
  "受講者",
  "プラン",
];

const WEEKDAYS = ["日", "月", "火", "水", "木", "金", "土"];

// Firestore Timestamp / Date のどちらでも Date に揃える
const toDate = (value) =>
  value && typeof value.toDate === "function" ? value.toDate() : new Date(value);

const pad2 = (n) => String(n).padStart(2, "0");

const formatDate = (date) =>
  `${date.getFullYear()}/${pad2(date.getMonth() + 1)}/${pad2(date.getDate())}`;

// 出席記録1件 → CSV1行分の配列
const toRow = (record) => {
  const date = toDate(record.date);
  return {
    sortKey: date.getTime(),
    values: [
      formatDate(date),
      WEEKDAYS[date.getDay()],
      record.time || "",
      record.studio_name || "",
      record.lesson_name || "",
      record.instructor_name || "",
      record.name || "",
      record.plan_name || "",
    ],
  };
};

// 日付 → 時間 → 校舎 → レッスン → 受講者 の順に並べる
const compareRows = (a, b) => {
  if (a.sortKey !== b.sortKey) return a.sortKey - b.sortKey;
  for (let i = 2; i <= 6; i += 1) {
    const cmp = a.values[i].localeCompare(b.values[i], "ja");
    if (cmp !== 0) return cmp;
  }
  return 0;
};

export const buildAttendanceRows = (records) =>
  records
    .map(toRow)
    .sort(compareRows)
    .map((row) => row.values);

// CSV セルのエスケープ。Excel の数式実行を防ぐため =,+,-,@ 始まりは ' を前置。
export const escapeCell = (value) => {
  const text = String(value ?? "");
  const safe = /^[=+\-@]/.test(text) ? `'${text}` : text;
  return /[",\r\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

// Excel で文字化けしないよう BOM 付き・CRLF 改行で出力
export const toCsv = (rows) =>
  "﻿" +
  [CSV_HEADERS, ...rows]
    .map((row) => row.map(escapeCell).join(","))
    .join("\r\n");
